module.exports = ['events.list.filters.dates.title', 'events.show.section.varnishing', 'events.show.section.ticketprice', 'events.show.section.place', 'events.show.section.address', 'events.show.section.schedules'];
